import { CourseLevel } from "@shared_types";

export const getProgressColors = (progress?: number) => {
  let progressColor = "var(--color-grey)";
  let progressTrackColor = "var(--color-grey-light)";
  
  if (progress !== undefined) {
    if (progress <= 33) {
      progressColor = "var(--color-yellow)";
      progressTrackColor = "#fcf0c3";
    } else if (progress <= 66) {
      progressColor = "var(--color-blue)";
      progressTrackColor = "var(--color-light-blue)";
    } else {
      progressColor = "var(--color-green)";
      progressTrackColor = "#E2F5E9";
    }
  }

  return { progressColor, progressTrackColor };
};

export const getLevelColor = (level?: CourseLevel) => {
  let levelColor = "var(--color-grey)";
  
  if (level?.name === "Super Beginner") {
    levelColor = "var(--color-green)";
  } else if (level?.name === "Beginner" || level?.name === "Upper Beginner") {
    levelColor = "var(--color-blue)";
  } else if (level?.name === "Intermediate" || level?.name === "Upper Intermediate") {
    levelColor = "var(--color-yellow)";
  } else if (level?.name === "Advanced" || level?.name === "Upper Advanced") {
    levelColor = "var(--color-orange)";
  }

  return levelColor;
}; 